import { Skeleton } from '@/shared/ui/atoms';

const CARD =
  'rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface p-xxs shadow-level1';

/** Campo de formulário: rótulo + input. */
function FieldSkeleton({ className = '' }: { readonly className?: string }) {
  return (
    <div className={`flex flex-col gap-quark ${className}`}>
      <Skeleton className="h-micro w-[5rem]" />
      <Skeleton className="h-sm w-full" />
    </div>
  );
}

/**
 * Skeleton de carregamento da tela de cadastro/edição de módulo. Reflete o layout
 * do `ClassModuleFormTemplate` (cabeçalho + card Geral/Turma + card Disciplinas +
 * ações) enquanto o detalhe do módulo é carregado, no lugar de blocos soltos.
 */
export function ClassModuleFormSkeleton() {
  return (
    <div className="flex flex-col gap-xxs">
      {/* Cabeçalho da página */}
      <div className="flex flex-col gap-quark">
        <Skeleton className="h-micro w-[9rem]" />
        <Skeleton className="h-xs w-[16rem]" />
      </div>

      {/* Card: Geral + Turma */}
      <section className={`${CARD} flex flex-col gap-xs`}>
        <FieldSkeleton className="max-w-[32rem]" />

        <div className="grid grid-cols-1 gap-xxxs md:grid-cols-[2fr_1fr_1fr]">
          <FieldSkeleton />
          <FieldSkeleton />
          <FieldSkeleton />
        </div>

        <FieldSkeleton className="max-w-[16rem]" />

        {/* Seção Turma */}
        <div className="border-ctx-layout-border border-b-hairline pb-nano">
          <Skeleton className="h-xs w-[8rem]" />
        </div>
        <div className="flex items-end gap-micro">
          <FieldSkeleton className="max-w-[35rem] flex-1" />
          <Skeleton className="h-sm w-[6rem]" />
        </div>
        <Skeleton className="h-[6rem] w-full rounded-sm" />
      </section>

      {/* Card: Aulas e Disciplinas */}
      <section className={CARD}>
        <div className="flex items-center justify-between border-ctx-layout-border border-b-hairline pb-nano">
          <Skeleton className="h-xs w-[12rem]" />
          <Skeleton className="h-sm w-[10rem]" />
        </div>
        <Skeleton className="mt-xs h-[8rem] w-full rounded-sm" />
      </section>

      {/* Ações */}
      <div className="flex gap-nano">
        <Skeleton className="h-sm w-[6rem]" />
        <Skeleton className="h-sm w-[6rem]" />
      </div>
    </div>
  );
}
